import { render, staticRenderFns } from "./GetRewardLockModal.vue?vue&type=template&id=939be11a&scoped=true"
import script from "./GetRewardLockModal.vue?vue&type=script&lang=js"
export * from "./GetRewardLockModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "939be11a",
  null
  
)

export default component.exports